import { render, staticRenderFns } from "./BCXEditedIndicator.vue?vue&type=template&id=f8da01a0&scoped=true"
import script from "./BCXEditedIndicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXEditedIndicator.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXEditedIndicator.vue?vue&type=style&index=0&id=f8da01a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8da01a0",
  null
  
)

export default component.exports